import { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";

import { login } from "../api/auth";
import { DEMO_EMAIL, DEMO_PASSWORD } from "../demo";
import LoadingSpinner from "./LoadingSpinner";
import { useAuthUser } from "./dashboard/hooks/useAuthUser";

/**
 * `/demo` — shareable entry point. No UI: it goes straight to the dashboard,
 * so the demo stays invisible to ordinary visitors on /login. A real signed-in
 * user is switched into demo mode too; the link should do what it says.
 */
export function DemoLoginRoute() {
  const { refreshAuth } = useAuthUser();
  const [status, setStatus] = useState<"pending" | "done" | "failed">("pending");
  // Guards against StrictMode's double-invoke. Do not add a `cancelled` flag:
  // StrictMode's cleanup fires between the two runs and would strand the spinner.
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    void (async () => {
      try {
        const data = await login({ email: DEMO_EMAIL, password: DEMO_PASSWORD });
        localStorage.setItem("token", data.token);
        refreshAuth();
        setStatus("done");
      } catch {
        setStatus("failed");
      }
    })();
  }, [refreshAuth]);

  if (status === "done") return <Navigate to="/dashboard" replace />;
  if (status === "failed") return <Navigate to="/login" replace />;

  return <LoadingSpinner className="loading-spinner-container--fullscreen" />;
}
